@import 'styles/mixins';
@import 'styles/variables';

.presenceOutOfViewContainer {
  display: none;

  @include for-desktop-up {
    display: flex;
    justify-content: flex-end;
  }
}

.directionAndAvatars {
  display: flex;
  align-items: center;
  border: 1px solid $grey-20;
  border-radius: 25px; // value doesn't matter as long as it's > 20px
  padding: 3px;
  background: var(--white);
}

.directionArrow {
  margin-right: 5px;
  color: $grey-30;
}
